import React from "react";
import { ArrowRight } from "lucide-react";
import { CONTACT_BG } from "../mock";
import { useEnquiry } from "../context/EnquiryContext";

const ContactCTA = () => {
  const { open: openEnquiry } = useEnquiry();
  return (
    <section id="contact" className="relative overflow-hidden py-28 md:py-40">
      <div className="absolute inset-0">
        <img
          src={CONTACT_BG}
          alt="Essex wedding"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-[#1f1d1a]/70" />
      </div>

      <div className="relative z-10 max-w-[1100px] mx-auto px-6 md:px-10 text-center text-[#f5efe6]">
        <p className="kicker text-[#c9a87c] mb-6 reveal">Don't miss out</p>
        <h2 className="font-display display-tight text-5xl md:text-7xl mb-8 reveal">
          Ready to save<br/>
          <span className="italic font-light">your date?</span>
        </h2>
        <p className="max-w-xl mx-auto font-light text-[#e8dfc9] text-lg leading-relaxed mb-12 reveal">
          We only take a limited number of weddings each month. Drop your details and we’ll get back to you within 24 hours.
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap reveal">
          <button
            onClick={openEnquiry}
            className="btn-primary"
            style={{ background:"#f5efe6", color:"#1f1d1a", borderColor:"#f5efe6" }}
          >
            Save Your Date <ArrowRight size={16} />
          </button>
        </div>
        <p className="mt-8 text-[#e8dfc9]/70 text-xs tracking-[0.25em] uppercase reveal">
          No pressure. We’ll get back to you within 24 hours.
        </p>
      </div>
    </section>
  );
};

export default ContactCTA;
